import {faChevronRight} from '@fortawesome/pro-regular-svg-icons';
import {SubTrigger} from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {DropdownMenuSubTriggerProps} from '@radix-ui/react-dropdown-menu';

export function DropdownSubTrigger({
  ref: forwardedRef,
  children,
  className,
  ...props
}: DropdownMenuSubTriggerProps &
  React.RefAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <SubTrigger
      {...props}
      ref={forwardedRef}
      className={clsx(
        className,
        'flex cursor-pointer items-center justify-between px-2 py-1 text-sm radix-highlighted:bg-blue10 radix-highlighted:font-semibold radix-highlighted:text-white radix-highlighted:outline-hidden'
      )}
    >
      {children}

      <Icon size="xs" icon={faChevronRight} />
    </SubTrigger>
  );
}

DropdownSubTrigger.displayName = 'DropdownSubTrigger';
